import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { getToken } from "../../utils/utils";

export const fetchHome = createAsyncThunk(
  "fetchHome",
  async (data, thunkAPI) => {
    const url = process.env.REACT_APP_API_URL + "/controller/home/list.php";
    const authorization = getToken();
    const options = {
      method: "GET",
      headers: {
        Authorization: "Bearer " + authorization,
      },
      data,
      url,
    };
    const response = await axios(options)
      .then((result) => {
        if (result.data) {
          return result.data.home;
        }
      })
      .catch((error) => {
        return error.code;
      });

    return response;
  }
);

export const fetchHomeSearch = createAsyncThunk(
  "fetchHomeSearch",
  async (data, thunkAPI) => {
    const url =
      process.env.REACT_APP_API_URL +
      "/controller/home/search.php?search=" +
      data;
    const authorization = getToken();
    const options = {
      method: "get",
      headers: {
        Authorization: "Bearer " + authorization,
      },
      url,
    };
    const response = await axios(options)
      .then((result) => {
        if (result.data) {
          return result.data.home;
        } else {
          return "Error";
        }
      })
      .catch((error) => {
        return error.code;
      });

    return response;
  }
);

export const fetchHomeEdit = createAsyncThunk(
  "fetchHomeEdit",
  async (data, thunkAPI) => {
    const url =
      process.env.REACT_APP_API_URL +
      "/controller/home/details.php?id=" +
      +data.id;
    const authorization = getToken();
    const options = {
      method: "get",
      headers: {
        Authorization: "Bearer " + authorization,
      },
      url,
    };
    const response = await axios(options)
      .then((result) => {
        if (result.data) {
          return result.data.home[0];
        } else {
          return "Error";
        }
      })
      .catch((error) => {
        return error.code;
      });

    return response;
  }
);

export const saveHome = createAsyncThunk("saveHome", async (data, thunkAPI) => {
  const url = process.env.REACT_APP_API_URL + "/controller/home/create.php";
  const authorization = getToken();
  const options = {
    method: "post",
    headers: {
      Authorization: "Bearer " + authorization,
      "Content-Type": "multipart/form-data",
    },
    url,
    data: data,
  };
  const response = await axios(options)
    .then((result) => {
      if (result.data) {
        if (result.data.home) return result.data.home;
        else return result.data.message;
      } else {
        return "Error";
      }
    })
    .catch((error) => {
      return error.code;
    });

  return response;
});

export const editHome = createAsyncThunk("editHome", async (data, thunkAPI) => {
  const url = process.env.REACT_APP_API_URL + "/controller/home/update.php";
  const authorization = getToken();
  const options = {
    method: "post",
    headers: {
      Authorization: "Bearer " + authorization,
      "Content-Type": "multipart/form-data",
    },
    url,
    data: data,
  };
  const response = await axios(options)
    .then((result) => {
      if (result.data) {
        if (result.data.home) return result.data.home;
        else return result.data.message;
      }
    })
    .catch((error) => {
      return error.code;
    });

  return response;
});

export const deleteHome = createAsyncThunk(
  "home/deleteHome",
  async (id, thunkAPI) => {
    const url =
      process.env.REACT_APP_API_URL + "/controller/home/delete.php?id=" + +id;
    const authorization = getToken();
    const options = {
      method: "delete",
      headers: { Authorization: "Bearer " + authorization },
      url,
    };
    const response = await axios(options)
      .then((result) => {
        return result.status;
      })
      .catch((error) => {
        return error.code;
      });

    return response;
  }
);
